export interface ThemeColors {
  '--background': string;
  '--foreground': string;
  '--card': string;
  '--card-foreground': string;
  '--primary': string;
  '--primary-foreground': string;
  '--secondary': string;
  '--secondary-foreground': string;
  '--muted': string;
  '--muted-foreground': string;
  '--accent': string;
  '--accent-foreground': string;
  '--border': string;
  '--ring': string;
  '--glow-rust': string;
  '--glow-sage': string;
}

export const themeMap: Record<string, ThemeColors> = {
  'theme-rust-sage': {
    '--background': '30 20% 96%',
    '--foreground': '20 18% 15%',
    '--card': '30 15% 99%',
    '--card-foreground': '20 18% 15%',
    '--primary': '12 60% 45%',
    '--primary-foreground': '30 20% 98%',
    '--secondary': '30 14% 91%',
    '--secondary-foreground': '20 14% 32%',
    '--muted': '30 10% 88%',
    '--muted-foreground': '20 8% 46%',
    '--accent': '150 25% 42%',
    '--accent-foreground': '30 20% 98%',
    '--border': '30 12% 86%',
    '--ring': '12 60% 45%',
    '--glow-rust': '12 60% 45%',
    '--glow-sage': '150 25% 42%',
  },
  'theme-forest-trail': {
    '--background': '140 12% 96%',
    '--foreground': '150 20% 12%',
    '--card': '140 10% 99%',
    '--card-foreground': '150 20% 12%',
    '--primary': '145 40% 32%',
    '--primary-foreground': '140 20% 98%',
    '--secondary': '140 10% 90%',
    '--secondary-foreground': '150 14% 30%',
    '--muted': '140 8% 87%',
    '--muted-foreground': '150 8% 44%',
    '--accent': '28 50% 45%',
    '--accent-foreground': '140 20% 98%',
    '--border': '140 10% 85%',
    '--ring': '145 40% 32%',
    '--glow-rust': '145 40% 32%',
    '--glow-sage': '28 50% 45%',
  },
  'theme-mountain-summit': {
    '--background': '215 12% 96%',
    '--foreground': '220 18% 14%',
    '--card': '215 10% 99%',
    '--card-foreground': '220 18% 14%',
    '--primary': '220 50% 48%',
    '--primary-foreground': '215 20% 98%',
    '--secondary': '215 10% 90%',
    '--secondary-foreground': '220 14% 30%',
    '--muted': '215 8% 87%',
    '--muted-foreground': '220 8% 44%',
    '--accent': '195 45% 42%',
    '--accent-foreground': '215 20% 98%',
    '--border': '215 10% 85%',
    '--ring': '220 50% 48%',
    '--glow-rust': '220 50% 48%',
    '--glow-sage': '195 45% 42%',
  },
  'theme-taking-flight': {
    '--background': '40 22% 96%',
    '--foreground': '35 20% 14%',
    '--card': '40 18% 99%',
    '--card-foreground': '35 20% 14%',
    '--primary': '35 80% 48%',
    '--primary-foreground': '40 20% 98%',
    '--secondary': '40 14% 90%',
    '--secondary-foreground': '35 14% 30%',
    '--muted': '40 10% 87%',
    '--muted-foreground': '35 8% 44%',
    '--accent': '200 50% 48%',
    '--accent-foreground': '40 20% 98%',
    '--border': '40 12% 85%',
    '--ring': '35 80% 48%',
    '--glow-rust': '35 80% 48%',
    '--glow-sage': '200 50% 48%',
  },
  'theme-fantasy-quest': {
    '--background': '270 12% 96%',
    '--foreground': '275 18% 14%',
    '--card': '270 10% 99%',
    '--card-foreground': '275 18% 14%',
    '--primary': '275 50% 45%',
    '--primary-foreground': '270 20% 98%',
    '--secondary': '270 10% 90%',
    '--secondary-foreground': '275 14% 30%',
    '--muted': '270 8% 87%',
    '--muted-foreground': '275 8% 44%',
    '--accent': '42 70% 50%',
    '--accent-foreground': '270 20% 14%',
    '--border': '270 10% 85%',
    '--ring': '275 50% 45%',
    '--glow-rust': '275 50% 45%',
    '--glow-sage': '42 70% 50%',
  },
  'theme-open-road': {
    '--background': '25 16% 95%',
    '--foreground': '200 18% 14%',
    '--card': '25 12% 99%',
    '--card-foreground': '200 18% 14%',
    '--primary': '200 55% 42%',
    '--primary-foreground': '25 20% 98%',
    '--secondary': '25 10% 90%',
    '--secondary-foreground': '200 14% 30%',
    '--muted': '25 8% 87%',
    '--muted-foreground': '200 8% 44%',
    '--accent': '25 60% 50%',
    '--accent-foreground': '25 20% 98%',
    '--border': '25 10% 85%',
    '--ring': '200 55% 42%',
    '--glow-rust': '200 55% 42%',
    '--glow-sage': '25 60% 50%',
  },
};

export function applyTheme(themeId: string) {
  const colors = themeMap[themeId];
  if (!colors) return;
  const root = document.documentElement;
  Object.entries(colors).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}

export function resetTheme() {
  const root = document.documentElement;
  const defaultColors = themeMap['theme-rust-sage'];
  Object.entries(defaultColors).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}
